module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/971a0912df6f4d8a673e067a2a77eb87.png";